<template>
<div class="side animate-box">
    
    <!-- <p><strong><span>Callback to discuss</span></strong></p> -->
    
    <div v-if="returnmsg==''">
        <p><span v-html="lang_detail['requiredDescription']"></span> (<span class="required_indicator">*</span>)</p>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="name" v-html="lang_detail['name']"></label>
                <input  type="text" id="name" autocomplete="name" class="form-control" v-model="name" ref="name" :aria-label="lang_detail['name']" aria-required="true" @keypress="isLetterWithSpace($event)" >
                <!-- pattern="[a-zA-Z]+" oninvalid="setCustomValidity('Please enter on alphabets only. ')" title="Please Enter Valid Name"-->
            </div>
            <span id="name_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="caseid" v-html="lang_detail['case_ID']"></label>                
                <input @keypress="isNumberWithHyphen($event)" type="text" id="caseid" autocomplete="id" class="form-control" v-model="caseId" ref="caseId" :aria-label="lang_detail['case_ID']" aria-required="true" >
            </div>
            <span id="caseId_validation_error" role="alert"></span>
        </div>
       <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="contactPreference" v-html="lang_detail['contact_prefer']"></label><br>
                
                <div class="margin-option">
                    <input type="radio" id="phone-radio" name="contactPreference" value="phone" v-model="contactPreference" ref="contactPreference" @click="enableDisablefields('phone')">
                    <label for="phone-radio" v-html="lang_detail['contactform_phone']"></label>
                </div>
                
                <div class="margin-option">
                    <input type="radio" id="emaill-radio" name="contactPreference" value="email" v-model="contactPreference" @click="enableDisablefields('email')">
                    <label for="emaill-radio" v-html="lang_detail['contactform_email']"></label>
                </div>
            </div>
            <span id="contactPreference_validation_error" role="alert"></span>
        </div>
        <div class="row form-group" v-if="flg_enable_email">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="emaill" v-html="lang_detail['email']"></label>
                <input type="email" @keypress="htmlfiveValidationErr($event)" id="emaill" class="form-control" v-model="email" ref='email' :aria-label="lang_detail['email']" title="enter valid email" maxlength="100">
            </div>
            <span id="email_validation_error" role="alert"></span>
        </div>
        <div class="row form-group" v-if="flg_enable_phone">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phone" v-html="lang_detail['phone']"></label>   <br/>  
                <select class="form-control cs_class" id="phone_code" name="phone_code" v-model="phone_code" ref="phone_code">
                    <option value="">phone &nbsp;&nbsp; code</option>
                    <option value="93">Afghanistan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+93</option>
                    <option value="358">Aland Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+358</option>
                    <option value="355">Albania  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+355</option>
                    <option value="213">Algeria  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+213</option>
                    <option value="1684">American Samoa  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1684</option>
                    <option value="376">Andorra  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+376</option>
                    <option value="244">Angola  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+244</option>
                    <option value="1264">Anguilla  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1264</option>
                    <option value="672">Antarctica  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+672</option>
                    <option value="1268">Antigua and Barbuda  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1268</option>
                    <option value="54">Argentina  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+54</option>
                    <option value="374">Armenia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+374</option>
                    <option value="297">Aruba  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+297</option>
                    <option value="61">Australia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+61</option>
                    <option value="43">Austria  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+43</option>
                    <option value="994">Azerbaijan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+994</option>
                    <option value="1242">Bahamas  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1242</option>
                    <option value="973">Bahrain  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+973</option>
                    <option value="880">Bangladesh  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+880</option>
                    <option value="1246">Barbados  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1246</option>
                    <option value="375">Belarus  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+375</option>
                    <option value="32">Belgium  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+32</option>
                    <option value="501">Belize  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+501</option>
                    <option value="229">Benin  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+229</option>
                    <option value="1441">Bermuda  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1441</option>
                    <option value="975">Bhutan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+975</option>
                    <option value="591">Bolivia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+591</option>
                    <option value="599">Bonaire, Sint Eustatius and Saba  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+599</option>
                    <option value="387">Bosnia and Herzegovina  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+387</option>
                    <option value="267">Botswana  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+267</option>
                    <option value="55">Bouvet Island  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+55</option>
                    <option value="55">Brazil  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+55</option>
                    <option value="246">British Indian Ocean Territory  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+246</option>
                    <option value="673">Brunei Darussalam  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+673</option>
                    <option value="359">Bulgaria  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+359</option>
                    <option value="226">Burkina Faso  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+226</option>
                    <option value="257">Burundi  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+257</option>
                    <option value="855">Cambodia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+855</option>
                    <option value="237">Cameroon  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+237</option>
                    <option value="1">Canada  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1</option>
                    <option value="238">Cape Verde  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+238</option>
                    <option value="1345">Cayman Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1345</option>
                    <option value="236">Central African Republic  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+236</option>
                    <option value="235">Chad  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+235</option>
                    <option value="56">Chile  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+56</option>
                    <option value="86">China  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+86</option>
                    <option value="61">Christmas Island  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+61</option>
                    <option value="672">Cocos (Keeling) Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+672</option>
                    <option value="57">Colombia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+57</option>
                    <option value="269">Comoros  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+269</option>
                    <option value="242">Congo  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+242</option>
                    <option value="242">Congo, Democratic Republic of the Congo  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+242</option>
                    <option value="682">Cook Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+682</option>
                    <option value="506">Costa Rica  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+506</option>
                    <option value="225">Cote D'Ivoire  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+225</option>
                    <option value="385">Croatia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+385</option>
                    <option value="53">Cuba  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+53</option>
                    <option value="599">Curacao  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+599</option>
                    <option value="357">Cyprus  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+357</option>
                    <option value="420">Czech Republic  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+420</option>
                    <option value="45">Denmark  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+45</option>
                    <option value="253">Djibouti  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+253</option>
                    <option value="1767">Dominica  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1767</option>
                    <option value="1809">Dominican Republic  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1809</option>
                    <option value="593">Ecuador  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+593</option>
                    <option value="20">Egypt  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+20</option>
                    <option value="503">El Salvador  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+503</option>
                    <option value="240">Equatorial Guinea  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+240</option>
                    <option value="291">Eritrea  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+291</option>
                    <option value="372">Estonia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+372</option>
                    <option value="251">Ethiopia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+251</option>
                    <option value="500">Falkland Islands (Malvinas)  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+500</option>
                    <option value="298">Faroe Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+298</option>
                    <option value="679">Fiji  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+679</option>
                    <option value="358">Finland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+358</option>
                    <option value="33">France  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+33</option>
                    <option value="594">French Guiana  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+594</option>
                    <option value="689">French Polynesia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+689</option>
                    <option value="262">French Southern Territories  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+262</option>
                    <option value="241">Gabon  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+241</option>
                    <option value="220">Gambia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+220</option>
                    <option value="995">Georgia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+995</option>
                    <option value="49">Germany  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+49</option>
                    <option value="233">Ghana  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+233</option>
                    <option value="350">Gibraltar  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+350</option>
                    <option value="30">Greece  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+30</option>
                    <option value="299">Greenland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+299</option>
                    <option value="1473">Grenada  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1473</option>
                    <option value="590">Guadeloupe  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+590</option>
                    <option value="1671">Guam  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1671</option>
                    <option value="502">Guatemala  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+502</option>
                    <option value="44">Guernsey  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+44</option>
                    <option value="224">Guinea  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+224</option>
                    <option value="245">Guinea-Bissau  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+245</option>
                    <option value="592">Guyana  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+592</option>
                    <option value="509">Haiti  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+509</option>
                    <option value="39">Holy See (Vatican City State)  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+39</option>
                    <option value="504">Honduras  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+504</option>
                    <option value="852">Hong Kong  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+852</option>
                    <option value="36">Hungary  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+36</option>
                    <option value="354">Iceland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+354</option>
                    <option value="91">India  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+91</option>
                    <option value="62">Indonesia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+62</option>
                    <option value="98">Iran, Islamic Republic of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+98</option>
                    <option value="964">Iraq  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+964</option>
                    <option value="353">Ireland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+353</option>
                    <option value="44">Isle of Man  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+44</option>
                    <option value="972">Israel  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+972</option>
                    <option value="39">Italy  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+39</option>
                    <option value="1876">Jamaica  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1876</option>
                    <option value="81">Japan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+81</option>
                    <option value="44">Jersey  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+44</option>
                    <option value="962">Jordan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+962</option>
                    <option value="7">Kazakhstan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+7</option>
                    <option value="254">Kenya  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+254</option>
                    <option value="686">Kiribati  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+686</option>
                    <option value="850">Korea, Democratic People's Republic of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+850</option>
                    <option value="82">Korea, Republic of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+82</option>
                    <option value="381">Kosovo  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+381</option>
                    <option value="965">Kuwait  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+965</option>
                    <option value="996">Kyrgyzstan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+996</option>
                    <option value="856">Lao People's Democratic Republic  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+856</option>
                    <option value="371">Latvia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+371</option>
                    <option value="961">Lebanon  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+961</option>
                    <option value="266">Lesotho  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+266</option>
                    <option value="231">Liberia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+231</option>
                    <option value="218">Libyan Arab Jamahiriya  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+218</option>
                    <option value="423">Liechtenstein  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+423</option>
                    <option value="370">Lithuania  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+370</option>
                    <option value="352">Luxembourg  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+352</option>
                    <option value="853">Macao  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+853</option>
                    <option value="389">Macedonia, the Former Yugoslav Republic of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+389</option>
                    <option value="261">Madagascar  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+261</option>
                    <option value="265">Malawi  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+265</option>
                    <option value="60">Malaysia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+60</option>
                    <option value="960">Maldives  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+960</option>
                    <option value="223">Mali  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+223</option>
                    <option value="356">Malta  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+356</option>
                    <option value="692">Marshall Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+692</option>
                    <option value="596">Martinique  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+596</option>
                    <option value="222">Mauritania  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+222</option>
                    <option value="230">Mauritius  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+230</option>
                    <option value="262">Mayotte  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+262</option>
                    <option value="52">Mexico  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+52</option>
                    <option value="691">Micronesia, Federated States of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+691</option>
                    <option value="373">Moldova, Republic of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+373</option>
                    <option value="377">Monaco  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+377</option>
                    <option value="976">Mongolia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+976</option>
                    <option value="382">Montenegro  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+382</option>
                    <option value="1664">Montserrat  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1664</option>
                    <option value="212">Morocco  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+212</option>
                    <option value="258">Mozambique  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+258</option>
                    <option value="95">Myanmar  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+95</option>
                    <option value="264">Namibia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+264</option>
                    <option value="674">Nauru  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+674</option>
                    <option value="977">Nepal  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+977</option>
                    <option value="31">Netherlands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+31</option>
                    <option value="599">Netherlands Antilles  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+599</option>
                    <option value="687">New Caledonia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+687</option>
                    <option value="64">New Zealand  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+64</option>
                    <option value="505">Nicaragua  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+505</option>
                    <option value="227">Niger  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+227</option>
                    <option value="234">Nigeria  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+234</option>
                    <option value="683">Niue  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+683</option>
                    <option value="672">Norfolk Island  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+672</option>
                    <option value="1670">Northern Mariana Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1670</option>
                    <option value="47">Norway  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+47</option>
                    <option value="968">Oman  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+968</option>
                    <option value="92">Pakistan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+92</option>
                    <option value="680">Palau  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+680</option>
                    <option value="970">Palestinian Territory, Occupied  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+970</option>
                    <option value="507">Panama  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+507</option>
                    <option value="675">Papua New Guinea  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+675</option>
                    <option value="595">Paraguay  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+595</option>
                    <option value="51">Peru  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+51</option>
                    <option value="63">Philippines  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+63</option>
                    <option value="64">Pitcairn  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+64</option>
                    <option value="48">Poland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+48</option>
                    <option value="351">Portugal  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+351</option>
                    <option value="1787">Puerto Rico  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1787</option>
                    <option value="974">Qatar  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+974</option>
                    <option value="262">Reunion  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+262</option>
                    <option value="40">Romania  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+40</option>
                    <option value="7">Russian Federation  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+7</option>
                    <option value="250">Rwanda  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+250</option>
                    <option value="590">Saint Barthelemy  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+590</option>
                    <option value="290">Saint Helena  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+290</option>
                    <option value="1869">Saint Kitts and Nevis  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1869</option>
                    <option value="1758">Saint Lucia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1758</option>
                    <option value="590">Saint Martin  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+590</option>
                    <option value="508">Saint Pierre and Miquelon  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+508</option>
                    <option value="1784">Saint Vincent and the Grenadines  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1784</option>
                    <option value="684">Samoa  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+684</option>
                    <option value="378">San Marino  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+378</option>
                    <option value="239">Sao Tome and Principe  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+239</option>
                    <option value="966">Saudi Arabia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+966</option>
                    <option value="221">Senegal  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+221</option>
                    <option value="381">Serbia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+381</option>
                    <option value="381">Serbia and Montenegro  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+381</option>
                    <option value="248">Seychelles  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+248</option>
                    <option value="232">Sierra Leone  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+232</option>
                    <option value="65">Singapore  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+65</option>
                    <option value="721">Sint Maarten  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+721</option>
                    <option value="421">Slovakia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+421</option>
                    <option value="386">Slovenia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+386</option>
                    <option value="677">Solomon Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+677</option>
                    <option value="252">Somalia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+252</option>
                    <option value="27">South Africa  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+27</option>
                    <option value="500">South Georgia and the South Sandwich Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+500</option>
                    <option value="211">South Sudan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+211</option>
                    <option value="34">Spain  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+34</option>
                    <option value="94">Sri Lanka  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+94</option>
                    <option value="249">Sudan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+249</option>
                    <option value="597">Suriname  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+597</option>
                    <option value="47">Svalbard and Jan Mayen  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+47</option>
                    <option value="268">Swaziland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+268</option>
                    <option value="46">Sweden  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+46</option>
                    <option value="41">Switzerland  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+41</option>
                    <option value="963">Syrian Arab Republic  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+963</option>
                    <option value="886">Taiwan, Province of China  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+886</option>
                    <option value="992">Tajikistan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+992</option>
                    <option value="255">Tanzania, United Republic of  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+255</option>
                    <option value="66">Thailand  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+66</option>
                    <option value="670">Timor-Leste  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+670</option>
                    <option value="228">Togo  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+228</option>
                    <option value="690">Tokelau  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+690</option>
                    <option value="676">Tonga  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+676</option>
                    <option value="1868">Trinidad and Tobago  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1868</option>
                    <option value="216">Tunisia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+216</option>
                    <option value="90">Turkey  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+90</option>
                    <option value="7370">Turkmenistan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+7370</option>
                    <option value="1649">Turks and Caicos Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1649</option>
                    <option value="688">Tuvalu  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+688</option>
                    <option value="256">Uganda  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+256</option>
                    <option value="380">Ukraine  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+380</option>
                    <option value="971">United Arab Emirates  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+971</option>
                    <option value="44">United Kingdom  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+44</option>
                    <option value="1">United States  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1</option>
                    <option value="1">United States Minor Outlying Islands  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1</option>
                    <option value="598">Uruguay  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+598</option>
                    <option value="998">Uzbekistan  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+998</option>
                    <option value="678">Vanuatu  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+678</option>
                    <option value="58">Venezuela  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+58</option>
                    <option value="84">Viet Nam  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+84</option>
                    <option value="1284">Virgin Islands, British  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1284</option>
                    <option value="1340">Virgin Islands, U.s.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1340</option>
                    <option value="681">Wallis and Futuna  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+681</option>
                    <option value="212">Western Sahara  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+212</option>
                    <option value="967">Yemen  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+967</option>
                    <option value="260">Zambia  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+260</option>
                    <option value="263">Zimbabwe  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+263</option>

                </select>

                <input @keypress="isNumberWithHyphen($event)" type="text" id="phone" class="form-control cs_phone_num" v-model="phone" ref="phone" :aria-label="lang_detail['phone']" aria-required="true" maxlength="10">
            </div>
            <span id="phone_code_validation_error" role="alert"></span>
            <span id="phone_validation_error" role="alert"></span>
        </div>
        <div class="row form-group" v-if="flg_enable_phone">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phoneMsg" v-html="lang_detail['phoneMsg']"></label>
                <select name="phoneMsg" id="phoneMsg" v-model="phoneMsg" class="form-control" ref="phoneMsg" :aria-label="lang_detail['phoneMsg']" aria-required="true">
                    <option :value="lang_detail['no']" selected aria-label="no 1 of 2">{{lang_detail['no']}}</option>
                    <option :value="lang_detail['yes']" aria-label="yes 2 of 2">{{lang_detail['yes']}}</option>
                </select>
                <span id="phoneMsg_validation_error" role="alert"></span>
            </div>
        </div>
        <div class="row form-group" v-if="flg_enable_phone">
            <div class="col-md-12">
                <label for="bestTime" v-html="lang_detail['phoneTimes']"></label>
                <select name="bestTime" id="bestTime" v-model="best_time" class="form-control" ref="bestTime" :aria-label="lang_detail['phoneTimes']">
                    <option v-html="lang_detail['anytime']" selected :aria-label="lang_detail['anytime']+' 1 of 4'"></option>
                    <option v-html="lang_detail['morning']" :aria-label="lang_detail['morning']+' 2 of 4'"></option>
                    <option v-html="lang_detail['afternoon']" :aria-label="lang_detail['afternoon']+' 3 of 4'"></option>
                    <option v-html="lang_detail['evening']" :aria-label="lang_detail['evening']+' 4 of 4'"></option>
                </select>            
            </div>
        </div>
        <!-- <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="country_list" v-html="lang_detail['country']"></label>
                <select name="country" v-model="country" id="country_list" class="form-control" ref="country" aria-label="Country" aria-required="true">
                    <option value=""></option>
                    <option value="Afghanistan" aria-label="Afganistan 2 of 196">Afghanistan</option>
                    <option value="Albania"  aria-label="Albania 3 of 196">Albania</option>
                    <option value="Algeria"  aria-label="Algeria 4 of 196">Algeria</option>
                    <option value="American Samoa"  aria-label="American Samoa 5 of 196">American Samoa</option>
                    <option value="Angola"  aria-label="Angola 6 of 196">Angola</option>
                    <option value="Antarctica"  aria-label="Antartica 7 of 196">Antarctica</option>
                    <option value="Argentina"  aria-label="Argentina 8 of 196">Argentina</option>
                    <option value="Armenia"  aria-label="Armenia 9 of 196">Armenia</option>
                    <option value="Aruba"  aria-label="Aruba 10 of 196">Aruba</option>
                    <option value="Australia"  aria-label="Australia 11 of 196">Australia</option>
                    <option value="Austria"  aria-label="Austria 12 of 196">Austria</option>
                    <option value="Azerbaijan"  aria-label="Azerbaijan 13 of 196">Azerbaijan</option>
                    <option value="Azores"  aria-label="Azores 14 of 196">Azores</option>
                    <option value="Bahamas"  aria-label="Bahamas 15 of 196">Bahamas</option>
                    <option value="Bahrain"  aria-label="Bahrain 16 of 196">Bahrain</option>
                    <option value="Baloush (Iran - Baluchistan Region)"  aria-label="Baloush Iran - Baluchistan Region 17 of 196">Baloush (Iran - Baluchistan Region)</option>
                    <option value="Bangladesh"  aria-label="Bangladesh 18 of 196">Bangladesh</option>
                    <option value="Barbados"  aria-label="Barbados 19 of 196">Barbados</option>
                    <option value="Belarus"  aria-label="Belarus 20 of 196">Belarus</option>
                    <option value="Belgium"  aria-label="Belgium 21 of 196">Belgium</option>
                    <option value="Belize"  aria-label="Belize 22 of 196">Belize</option>
                    <option value="Benin"  aria-label="Benin 23 of 196">Benin</option>
                    <option value="Bermuda"  aria-label="Bermuda 24 of 196">Bermuda</option>
                    <option value="Bolivia"  aria-label="Bolivia 25 of 196">Bolivia</option>
                    <option value="Bosnia &amp; Herzegovina"  aria-label="Bosnia and Herzegovina 26 of 196">Bosnia &amp; Herzegovina</option>
                    <option value="Botswana"  aria-label="Botswana 27 of 196">Botswana</option>
                    <option value="Brazil"  aria-label="Brazil 28 of 196">Brazil</option>
                    <option value="Bulgaria"  aria-label="Bulgaria 29 of 196">Bulgaria</option>
                    <option value="Burkina Faso"  aria-label="Burkina Faso 30 of 196">Burkina Faso</option>
                    <option value="Burundi"  aria-label="Burundi 31 of 196">Burundi</option>
                    <option value="Cambodia"  aria-label="Cambodia 32 of 196">Cambodia</option>
                    <option value="Cameroon"  aria-label="Cameroon 33 of 196">Cameroon</option>
                    <option value="Canada"  aria-label="Canada 34 of 196">Canada</option>
                    <option value="Cayman Islands"  aria-label="Cayman Island 35 of 196">Cayman Islands</option>
                    <option value="Central African Republic"  aria-label="Central African Republic 36 of 196">Central African Republic</option>
                    <option value="Chad"  aria-label="Chad 37 of 196">Chad</option>
                    <option value="Channel Islands"  aria-label="Channel Island 38 of 196">Channel Islands</option>
                    <option value="Chile"  aria-label="Chile 39 of 196">Chile</option>
                    <option value="China, PR"  aria-label="China PR 40 of 196">China, PR</option>
                    <option value="Colombia"  aria-label="Colombia 41 of 196">Colombia</option>
                    <option value="Congo" aria-label="Congo 42 of 196">Congo</option>
                    <option value="Costa Rica" aria-label="Costa Rica 43 of 196">Costa Rica</option>
                    <option value="Cote d'Ivoire" aria-label="Cote d'Ivoire 44 of 196">Cote d'Ivoire</option>
                    <option value="Croatia" aria-label="Croatia 45 of 196">Croatia</option>
                    <option value="Cuba" aria-label="Cuba 46 of 196">Cuba</option>
                    <option value="Cyprus" aria-label="Cyprus Rica 47 of 196">Cyprus</option>
                    <option value="Czech Republic" aria-label="Czech Republic 48 of 196">Czech Republic</option>
                    <option value="Denmark" aria-label="Denmark 49 of 196">Denmark</option>
                    <option value="Diego Garcia" aria-label="Diego Garcia 50 of 196">Diego Garcia</option>
                    <option value="Djibouti" aria-label="Djibouti 51 of 196">Djibouti</option>
                    <option value="Dominican Republic" aria-label="Dominican Republic 52 of 196">Dominican Republic</option>
                    <option value="East Timor" aria-label="East Timor 53 of 196">East Timor</option>
                    <option value="Ecuador" aria-label="Ecuador 54 of 196">Ecuador</option>
                    <option value="Egypt" aria-label="Egypt 55 of 196">Egypt</option>
                    <option value="El Salvador" aria-label="El Salvador 56 of 196">El Salvador</option>
                    <option value="Equatorial Guinea" aria-label="Equatorial Guinea 57 of 196">Equatorial Guinea</option>
                    <option value="Eritrea" aria-label="Eritrea 58 of 196">Eritrea</option>
                    <option value="Estonia" aria-label="Estonia 59 of 196">Estonia</option>
                    <option value="Ethiopia" aria-label="Ethiopia 60 of 196">Ethiopia</option>
                    <option value="Faeroe Islands" aria-label="Faeroe Islands 61 of 196">Faeroe Islands</option>
                    <option value="Fiji" aria-label="Fiji 62 of 196">Fiji</option>
                    <option value="Finland" aria-label="Finland 63 of 196">Finland</option>
                    <option value="France" aria-label="France 64 of 196">France</option>
                    <option value="Gabon" aria-label="Gabon 65 of 196">Gabon</option>
                    <option value="Gambia" aria-label="Gambia 66 of 196">Gambia</option>
                    <option value="Georgia" aria-label="Georgia 67 of 196">Georgia</option>
                    <option value="Germany" aria-label="Germany 68 of 196">Germany</option>
                    <option value="Ghana" aria-label="Ghana 69 of 196">Ghana</option>
                    <option value="Gibraltar" aria-label="Gibraltar 70 of 196">Gibraltar</option>
                    <option value="Greece" aria-label="Greece 71 of 196">Greece</option>
                    <option value="Greenland" aria-label="Greenland 72 of 196">Greenland</option>
                    <option value="Guam" aria-label="Guam 73 of 196">Guam</option>
                    <option value="Guatemala" aria-label="Guatemala 74 of 196">Guatemala</option>
                    <option value="Guinea" aria-label="Guinea 75 of 196">Guinea</option>
                    <option value="Guinea-Bissau" aria-label="Guinea Bissau 76 of 196">Guinea-Bissau</option>
                    <option value="Guyana" aria-label="Guyana 77 of 196">Guyana</option>
                    <option value="Haiti" aria-label="Haiti 78 of 196">Haiti</option>
                    <option value="Honduras" aria-label="Honduras 79 of 196">Honduras</option>
                    <option value="Hong Kong" aria-label="Hong kong 80 of 196">Hong Kong</option>
                    <option value="Hungary" aria-label="Hungary 81 of 196">Hungary</option>
                    <option value="Iceland" aria-label="Iceland 82 of 196">Iceland</option>
                    <option value="India" aria-label="India 83 of 196">India</option>
                    <option value="Indonesia" aria-label="Indonesia 84 of 196">Indonesia</option>
                    <option value="Iran" aria-label="Iran 85 of 196">Iran</option>
                    <option value="Iraq" aria-label="Iraq 86 of 196">Iraq</option>
                    <option value="Ireland" aria-label="Ireland 87 of 196">Ireland</option>
                    <option value="Israel" aria-label="Israel 88 of 196">Israel</option>
                    <option value="Italy" aria-label="Italy 89 of 196">Italy</option>
                    <option value="Jamaica" aria-label="Jamaica 90 of 196">Jamaica</option>
                    <option value="Japan" aria-label="Japan 91 of 196">Japan</option>
                    <option value="Jordan" aria-label="Jordan 92 of 196">Jordan</option>
                    <option value="Kazakhstan" aria-label="Kazakhstan 93 of 196">Kazakhstan</option>
                    <option value="Kenya" aria-label="Kenya 94 of 196">Kenya</option>
                    <option value="Kosovo" aria-label="Kosova 95 of 196">Kosovo</option>
                    <option value="Kuwait" aria-label="Kuwait 96 of 196">Kuwait</option>
                    <option value="Kyrgyzstan" aria-label="Kyrgystan 97 of 196">Kyrgyzstan</option>
                    <option value="Laos" aria-label="Laos 98 of 196">Laos</option>
                    <option value="Latvia" aria-label="Latvia 99 of 196">Latvia</option>
                    <option value="Lebanon" aria-label="Lebanon 100 of 196">Lebanon</option>
                    <option value="Lesotho" aria-label="Lesotho 101 of 196">Lesotho</option>
                    <option value="Liberia" aria-label="Liberia 102 of 196">Liberia</option>
                    <option value="Libya" aria-label="Libya 103 of 196">Libya</option>
                    <option value="Lithuania" aria-label="Lithuania 104 of 196">Lithuania</option>
                    <option value="Luxembourg" aria-label="Luxembourg 105 of 196">Luxembourg</option>
                    <option value="Macau" aria-label="Macau 106 of 196">Macau</option>
                    <option value="Macedonia" aria-label="Macedonia 107 of 196">Macedonia</option>
                    <option value="Madagascar" aria-label="Madagascar 108 of 196">Madagascar</option>
                    <option value="Malawi" aria-label="Malawi 109 of 196">Malawi</option>
                    <option value="Malaysia" aria-label="Malaysia 110 of 196">Malaysia</option>
                    <option value="Mali, Republic of" aria-label="Mali, Republic of 111 of 196">Mali, Republic of</option>
                    <option value="Malta" aria-label="Malta 112 of 196">Malta</option>
                    <option value="Mauritania" aria-label="Mauritania 113 of 196">Mauritania</option>
                    <option value="Mauritius" aria-label="Mauritius 114 of 196">Mauritius</option>
                    <option value="Mexico" aria-label="Mexico 115 of 196">Mexico</option>
                    <option value="Moldova" aria-label="Moldova 116 of 196">Moldova</option>
                    <option value="Monaco" aria-label="Monaco 117 of 196">Monaco</option>
                    <option value="Mongolia" aria-label="Mangolia 118 of 196">Mongolia</option>
                    <option value="Montenegro" aria-label="Montenegro 119 of 196">Montenegro</option>
                    <option value="Morocco" aria-label="Morocco 120 of 196">Morocco</option>
                    <option value="Mozambique" aria-label="Mozambique 121 of 196">Mozambique</option>
                    <option value="Myanmar (Burma)" aria-label="Myanmar Burma 122 of 196">Myanmar (Burma)</option>
                    <option value="Namibia" aria-label="Namibia 123 of 196">Namibia</option>
                    <option value="Nepal" aria-label="nepal 124 of 196">Nepal</option>
                    <option value="Netherlands" aria-label="Netherlands 125 of 196">Netherlands</option>
                    <option value="New Zealand" aria-label="New Zealand 126 of 196">New Zealand</option>
                    <option value="Nicaragua" aria-label="Nicaragua 127 of 196">Nicaragua</option>
                    <option value="Nigeria" aria-label="Nigeria 128 of 196">Nigeria</option>
                    <option value="North Korea" aria-label="North Korea 129 of 196">North Korea</option>
                    <option value="Norway" aria-label="Norway 130 of 196">Norway</option>
                    <option value="Okinawa" aria-label="Okinawa 131 of 196">Okinawa</option>
                    <option value="Oman" aria-label="Oman 132 of 196">Oman</option>
                    <option value="Pakistan" aria-label="Pakistan 133 of 196">Pakistan</option>
                    <option value="Palestinian Territories" aria-label="Palestinian Territories 134 of 196">Palestinian Territories</option>
                    <option value="Panama" aria-label="Panama 134 of 196">Panama</option>
                    <option value="Papua New Guinea" aria-label="Papua New Guinea 135 of 196">Papua New Guinea</option>
                    <option value="Paraguay" aria-label="Paragua 136 of 196">Paraguay</option>
                    <option value="Peru" aria-label="Peru 137 of 196">Peru</option>
                    <option value="Philippines" aria-label="Philippines 138 of 196">Philippines</option>
                    <option value="Poland" aria-label="Poland 139 of 196">Poland</option>
                    <option value="Portugal" aria-label="Portugal 140 of 196">Portugal</option>
                    <option value="Puerto Rico" aria-label="Puerto Rico 141 of 196">Puerto Rico</option>
                    <option value="Qatar" aria-label="Qatar 142 of 196">Qatar</option>
                    <option value="Romania" aria-label="Romania 143 of 196">Romania</option>
                    <option value="Russia" aria-label="Rusiia 144 of 196">Russia</option>
                    <option value="Rwanda" aria-label="Rwanda 145 of 196">Rwanda</option>
                    <option value="Saudi Arabia" aria-label="Saudi Arabia 146 of 196">Saudi Arabia</option>
                    <option value="Senegal" aria-label="Senegal 147 of 196">Senegal</option>
                    <option value="Serbia" aria-label="Serbia 148 of 196">Serbia</option>
                    <option value="Seychelles" aria-label="Seychelles 149 of 196">Seychelles</option>
                    <option value="Sierra Leone" aria-label="Sierra Leone 150 of 196">Sierra Leone</option>
                    <option value="Singapore" aria-label="Singapore 151 of 196">Singapore</option>
                    <option value="Slovakia" aria-label="Slovakia 152 of 196">Slovakia</option>
                    <option value="Slovenia" aria-label="Slovenia 153 of 196">Slovenia</option>
                    <option value="Somalia" aria-label="Somalia 154 of 196">Somalia</option>
                    <option value="Somaliland" aria-label="Somaliland 155 of 196">Somaliland</option>
                    <option value="South Africa" aria-label="South Africa 156 of 196">South Africa</option>
                    <option value="South Korea" aria-label="South Korea 157 of 196">South Korea</option>
                    <option value="Spain" aria-label="Spain 158 of 196">Spain</option>
                    <option value="Sri Lanka" aria-label="Sri Lanka 159 of 196">Sri Lanka</option>
                    <option value="St. Lucia" aria-label="St. Lucia 160 of 196">St. Lucia</option>
                    <option value="St. Maarten" aria-label="St. Maarten 161 of 196">St. Maarten</option>
                    <option value="Sudan" aria-label="Sudan 162 of 196">Sudan</option>
                    <option value="Suriname" aria-label="Suriname 163 of 196">Suriname</option>
                    <option value="Swaziland" aria-label="Swaziland 164 of 196">Swaziland</option>
                    <option value="Sweden" aria-label="Sweden 165 of 196">Sweden</option>
                    <option value="Switzerland" aria-label="Switzerland 166 of 196">Switzerland</option>
                    <option value="Syria" aria-label="Syria 167 of 196">Syria</option>
                    <option value="Taiwan" aria-label="Taiwan 168 of 196">Taiwan</option>
                    <option value="Tajikistan" aria-label="Tajikistan 169 of 196">Tajikistan</option>
                    <option value="Tanzania" aria-label="Tanzania 170 of 196">Tanzania</option>
                    <option value="Thailand" aria-label="Thailand 171 of 196">Thailand</option>
                    <option value="Timor-Leste (East Timor)" aria-label="Timor Leste East Timor 172 of 196">Timor-Leste (East Timor)</option>
                    <option value="Togo (Togolese Republic)" aria-label="Togo Togolese Republic 173 of 196">Togo (Togolese Republic)</option>
                    <option value="Trinidad &amp; Tobago" aria-label="Trinidad and Tbago 174 of 196">Trinidad &amp; Tobago</option>
                    <option value="Tunisia" aria-label="Tunisia 175 of 196">Tunisia</option>
                    <option value="Turkey" aria-label="Turkey 176 of 196">Turkey</option>
                    <option value="Turkmenistan" aria-label="Turkmenistan 177 of 196">Turkmenistan</option>
                    <option value="Turks &amp; Caicos Islands" aria-label="Turks and Caicos Island 178 of 196">Turks &amp; Caicos Islands</option>
                    <option value="UAE" aria-label="UAE 179 of 196">UAE</option>
                    <option value="Uganda" aria-label="Uganda 180 of 196">Uganda</option>
                    <option value="UK - England" aria-label="UK - England 181 of 196">UK - England</option>
                    <option value="UK - Northern Ireland" aria-label="UK - Northern Ireland 182 of 196">UK - Northern Ireland</option>
                    <option value="UK - Scotland" aria-label="Uk - Scotland 183 of 196">UK - Scotland</option>
                    <option value="UK - Wales" aria-label="UK - Wales 184 of 196">UK - Wales</option>
                    <option value="Ukraine" aria-label="Ukraine 185 of 196">Ukraine</option>
                    <option value="Uruguay" aria-label="Uruguay 186 of 196">Uruguay</option>
                    <option value="USA" aria-label="USA 187 of 196">USA</option>
                    <option value="Uzbekistan" aria-label="Uzbekistan 188 of 196">Uzbekistan</option>
                    <option value="Venezuela" aria-label="Venezuela 189 of 196">Venezuela</option>
                    <option value="Vietnam" aria-label="Vietnam 190 of 196">Vietnam</option>
                    <option value="Virgin Islands - British" aria-label="Virgin Islands - British 191 of 196">Virgin Islands - British</option>
                    <option value="Virgin Islands - US" aria-label="Virgin Islands - US 192 of 196">Virgin Islands - US</option>
                    <option value="Yemen" aria-label="Yemen 193 of 196">Yemen</option>
                    <option value="Zambia" aria-label="Zambia 194 of 196">Zambia</option>
                    <option value="Zimbabwe" aria-label="Zimbabwe 195 of 196">Zimbabwe</option>
				</select>
            </div>
            <span id="country_validation_error"  role="alert"></span>
        </div> -->
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator"></span>
                <label for="yourNeed" v-html="lang_detail['case_description']"></label>
                <select name="yourNeed" id="yourNeed" v-model="yourNeed" class="form-control margin-btm" ref="yourNeed" :aria-label="lang_detail['case_description']" >
                    <option v-html="lang_detail['case_change']" :aria-label="lang_detail['case_change']+' 1 of 6'"></option>
                    <option v-html="lang_detail['case_expectation']" :aria-label="lang_detail['case_expectation']+' 2 of 6'"></option>
                    <option v-html="lang_detail['case_sessions']" :aria-label="lang_detail['case_sessions']+' 3 of 6'"></option>
                    <option v-html="lang_detail['case_complete']" :aria-label="lang_detail['case_complete']+' 4 of 6'"></option>
                    <option v-html="lang_detail['case_request']" :aria-label="lang_detail['case_request']+' 5 of 6'"></option>
                    <option v-html="lang_detail['case_reschedule']" :aria-label="lang_detail['case_reschedule']+' 6 of 6'"></option>
                </select>
                <span id="yourNeed_validation_error" role="alert"></span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <input type="checkbox" name="fterms" id="fterms" aria-required="true"  v-model="fterms" ref="fterms" aria-label="Accept terms and conditions">&nbsp;<span v-html="lang_detail['terms_check']"></span>
            </div>
            <span id="fterms_validation_error" role="alert"></span>
        </div>
        <!-- <div class="row form-group">
            <p></p>
        </div>  -->
        <div class="row form-group hhcap">
            <vue-hcaptcha :sitekey="$store.state.HC_SITE_KEY"  @verify="onVerify" @expired="onExpire" @error="onError"></vue-hcaptcha>
            <span id="hccaptcha_validation_error" role="alert"></span>
        </div>      
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" class="btn submit btn-primary" @click="sendForm()" v-html="lang_detail['submit']"></button>
        </div>
    </div>
    <p v-else v-html="returnmsg" role="alert"></p>
</div>    
</template>
<script>
import axios from 'axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
    name: 'CallbackCase',
    data(){
        return{
            lang_detail:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            languageData:this.$store.state.languageData,
            fterms:'',name:'',returnmsg:'',
            country:'',
            best_time:'',
            id_design:localStorage.id_design,
            yourNeed:'',
            verified: false,
            expired: false,
            token: null,
            eKey: null,
            error: null,
            disablefdbtn:false,
            caseId:'',
            contactPreference:'',
            flg_enable_phone:0,
            flg_enable_email:0,
            phone:'',
            phone_code:'',
            email:'',
            phoneMsg:'',
            phoneValidate:undefined,
            phoneMsgValidate:undefined,
            emailValidate:undefined
        };        
    },
    components:{
        VueHcaptcha       
    },
    mounted :function(){
        this.getlangVar()
    },
    created:function(){
    },
    watch: {
        name: function() {
            this.validateFormRemoveMarkers('name_validation_error');               
        },
        caseId: function() {
            this.validateFormRemoveMarkers('caseId_validation_error');               
        },        
        /* country: function() {
            this.validateFormRemoveMarkers('country_validation_error');               
        },  */    
        fterms: function() {
            this.validateFormRemoveMarkers('fterms_validation_error');               
        },
        contactPreference: function(){
            this.validateFormRemoveMarkers('contactPreference_validation_error');
        },
        verified: function() {
            this.validateFormRemoveMarkers('hccaptcha_validation_error');               
        },
        phone: function() {
            this.validateFormRemoveMarkers('phone_validation_error');               
        },
        email: function() {
            this.validateFormRemoveMarkers('email_validation_error');               
        },
        phoneMsg: function(){
            this.validateFormRemoveMarkers('phoneMsg_validation_error');
        },  
        phone_code: function(){
            this.validateFormRemoveMarkers('phone_code_validation_error');
        }, 
    },
	methods:{
        sendForm(){            
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('caseid', this.caseId)
            formData.append('contactPreference',this.contactPreference)
            //formData.append('country', this.country)
            formData.append('phone', this.phone)
            formData.append('phone_code', this.phone_code)
            formData.append('email', this.email)
            formData.append('bestTime', this.best_time)
            formData.append('phoneMsg',this.phoneMsg)
            formData.append('terms', this.fterms)
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('name_company', this.$store.state.companyData['name_company'])
            formData.append('id_eap', this.$store.state.companyData['id_eap'])
            formData.append('id_country', this.$store.state.companyData['id_country'])
            formData.append('name_eap', this.$store.state.companyDataInfo['name_eap'])
            formData.append('ucms_company', this.$store.state.companyDataInfo['ucms_company'])
            formData.append('yourNeed',this.yourNeed)
            formData.append('hc_token', this.token)
            //this.name,undefined,undefined,this.country,undefined,undefined,undefined,undefined,this.fterms,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,this.verified
            if(this.flg_enable_phone){
                this.phoneValidate=this.phone;
                this.phoneMsgValidate=this.phoneMsg;
                this.emailValidate=undefined;                 
                if (this.phone_code === '' && this.phone !== '') {
                    let errMsg='Code' + ' ' +this.$store.state.languageData['required'];
                    this.validateFormAddMarkers('phone_code_validation_error','dynamic_form_error_required',errMsg); 
                    $('#phone_code_validation_error').attr('aria-label',errMsg);
                    this.$refs.phone_code.focus();  
                    return 'false';
                } 
            }else{
                this.phoneValidate=undefined;
                this.phoneMsgValidate=undefined;
                this.emailValidate=this.email;
            }
           var validateForm = this.validateForm(this.name,this.phoneValidate,this.emailValidate,undefined,undefined,undefined,undefined,undefined,this.fterms,this.phoneMsgValidate,undefined,undefined,undefined,undefined,undefined,undefined,undefined,this.verified,undefined,undefined,undefined,this.caseId,this.contactPreference);           
           if(!validateForm){
        
                this.disablefdbtn=true;
                axios.post(this.$store.state.FORM_ACTION_DOMAIN+'/new_eesite_forms/call_back_case_form.php',formData,config)
                .then(response => {                    
                    if(response === undefined || response.length == 0 ){
                        this.returnmsg='! Something went wrong, Please try again'
                    }
                    else{
                        this.returnmsg = response.data;
                        this.web_hits("contact_existing_case_form_submit_clicked");                         
                    }                    
                })
                .catch(() => {                    
                    this.returnmsg='Try after sometime'
                });
                
            }
        },
        getlangVar(){
            document.querySelector('title').setAttribute("aria-busy", "true");
            var api_private_key=this.get_api_key_mix('lams')
            axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']                  
                }
            })
            .then(response => { 
                response = response.data;
                this.lang_detail = response;
                this.best_time=this.lang_detail['anytime'];
                var titleValue =this.lang_detail['callback_case'];                
                var home = this.lang_detail['d00'];
                this.$announcer.set(this.decodeHtmlLang(titleValue)+' form | '+this.$store.state.companyData['name_company']);
                document.title = this.decodeHtmlLang(titleValue)+' form | '+this.$store.state.companyData['name_company'];    
            })
            .catch(() => {
                this.main_content = []
            });
        },
        onVerify(token, ekey) {
            this.verified = true;
            this.token = token;
            this.eKey = ekey;
        },
        onExpire() {
            this.verified = false;
            this.token = null;
            this.eKey = null;
            this.expired = true;
        },
        onError(err) {
            this.token = null;
            this.eKey = null;
            this.error = err;
        },
        enableDisablefields(val){
            if(val=='phone'){
                this.flg_enable_phone=1;
                this.flg_enable_email=0;
            }else{
                this.flg_enable_email=1;
                this.flg_enable_phone=0;
            }          
        }
    }
};
</script>
<style scoped>
.margin-btm {
    margin-bottom: 10px;
}
label {
    padding: 5px;
}
.margin-option input{
    margin-right: 5px;
}
.form-group{
    margin-bottom: 40px;
}
.side{
   margin-left:15px; 
}

.side .submit{
    right: 20px !important;
}
@media screen and (max-width: 350px) {
    .side{
        margin-left:18px; 
    }
    .side .submit{
        right: 30px !important;
    }
}

.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.form-control {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
}
/* [aria-required=true] {
  border: red thin solid;
} */
.hhcap{
    padding-left: 1em;
}
.cs_class{
    width: 89px;
    direction: rtl;
    appearance: unset;
    display: inline-block;
}
.cs_phone_num{
    display: inline-block;
    width:270px;
}
</style>